import React, { useEffect, useRef, useState, useCallback } from 'react';
import BeforeAfterSlider from '../testimonials/BeforeAfterSlider';
import VideoTestimonials from './VideoTestimonials';
import Before1 from '../../Assets/TeamandOthers/Before_1.webp';
import Before2 from '../../Assets/TeamandOthers/Before_2.webp';
import Before3 from '../../Assets/TeamandOthers/Before_3.webp';
import After1 from '../../Assets/TeamandOthers/After_1.webp';
import After2 from '../../Assets/TeamandOthers/After_2.webp';
import After3 from '../../Assets/TeamandOthers/After_3.webp';

const testimonials = [
  {
    name: "DEEPAK PATEL",
    avatarBg: "bg-green-100",
    avatarText: "D",
    avatarColor: "text-green-700",
    rating: 5,
    text: "I am an NRI. Recently we visited this hospital after a feedback from my friend. very impressed with the treatment facilities and the specialized dentists. I strongly recommend this hospital.",
    date: "2 months ago"
  },
  {
    name: "SYAMALA, INFOSYS",
    avatarBg: "bg-purple-100",
    avatarText: "S",
    avatarColor: "text-purple-700",
    rating: 5,
    text: "My 21 years daughter has clips treatment at this hospital and we were very pleased with the treatment. Now the alignment is very good. Thanks to Dr. Raghavendra our Orthodontist.",
    date: "a week ago"
  },
  {
    name: "DR. CHARITHA NRI",
    avatarBg: "bg-purple-100",
    avatarText: "C",
    avatarColor: "text-purple-700",
    rating: 5,
    text: "Came from Austin, USA for Christmas vacation. Had Implants with immediate loading. Very happy. Same thing might have 6 times more in USA. Strongly recommend.",
    date: "a year ago"
  },
  {
    name: "LAKSHMI PUTTAGUNTA",
    avatarBg: "bg-purple-100",
    avatarText: "L",
    avatarColor: "text-purple-700",
    rating: 5,
    text: "I took my 8 year old son who has thumb sucking habit. I consulted pedodontist . Very impressed with the treatment result and now he stopped that habit. Very happy.",
    date: "6 months ago"
  },
];

const beforeAfterCases = [
  { beforeSrc: Before1, afterSrc: After1, title: "Full Smile Makeover", description: "Veneers + Whitening + Gum Contouring" },
  { beforeSrc: Before2, afterSrc: After2, title: "All-on-4 Full Mouth Implants", description: "Immediate loading with fixed bridge" },
  { beforeSrc: Before3, afterSrc: After3, title: "Orthodontic Correction", description: "Braces treatment – 18 months" },
];

const TestimonialSlider = () => {
  const trackRef = useRef(null);
  const scrollPosRef = useRef(0); // This maintains the exact pixel position
  const animationRef = useRef(null);
  
  const [isPaused, setIsPaused] = useState(false);
  const [showBeforeAfter, setShowBeforeAfter] = useState(false);

  const scrollSpeed = 0.6; // Speed: Pixels per frame (0.6 is smooth)

  // Function to handle the animation loop
  const animate = useCallback(() => {
    if (!trackRef.current) return;

    if (!isPaused) {
      const track = trackRef.current;
      const halfWidth = track.scrollWidth / 2;

      // Update position
      scrollPosRef.current += scrollSpeed;

      // Seamless Loop: If we scroll past the first set, reset to 0
      if (scrollPosRef.current >= halfWidth) {
        scrollPosRef.current = 0;
      }

      // Apply transform using hardware acceleration (translate3d)
      track.style.transform = `translate3d(-${scrollPosRef.current}px, 0, 0)`;
    }

    animationRef.current = requestAnimationFrame(animate);
  }, [isPaused]);

  useEffect(() => {
    animationRef.current = requestAnimationFrame(animate);
    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, [animate]);

  // Handle manual drag/swipe interactions
  const handleDrag = (e) => {
    // Optional: Add logic here if you want to allow users to flick the carousel
    // For now, the hover pause covers the "stop and look" requirement perfectly
  };

  return (
    <section className="py-16 md:py-20 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Patients Say
          </h2>
          <div className="flex items-center justify-center gap-3">
            <div className="flex items-center gap-1.5">
              <span className="text-3xl font-extrabold text-yellow-500">4.9</span>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>
            <span className="text-lg text-gray-600 font-medium">Based on 724 reviews</span>
          </div>
          <p className="text-gray-500 mt-1 text-sm">powered by Google</p>
        </div>

        {/* Carousel Area */}
        <div
          className="relative overflow-hidden cursor-default py-4"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            ref={trackRef}
            className="flex gap-6 will-change-transform"
            style={{ width: 'max-content' }}
          >
            {/* Double the array to create the infinite loop effect */}
            {[...testimonials, ...testimonials].map((t, idx) => (
              <div 
                key={idx} 
                className="w-[85vw] sm:w-[380px] lg:w-[350px] flex-shrink-0"
              >
                <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 h-full flex flex-col transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-blue-200">
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-12 h-12 rounded-full ${t.avatarBg} flex items-center justify-center text-xl font-bold ${t.avatarColor}`}>
                      {t.avatarText}
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-[16px]">{t.name}</h4>
                      <div className="flex text-yellow-400 text-sm">
                        {'★'.repeat(t.rating)}
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-700 leading-relaxed flex-grow text-[14.5px]">
                    "{t.text}"
                  </p>
                  <p className="text-[12px] text-gray-400 mt-5 pt-4 border-t border-gray-50">
                    {t.date}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Video Testimonials */}
<VideoTestimonials />

        {/* Section Toggle Button */}
        
        <div className="text-center">
          <button
            onClick={() => setShowBeforeAfter(!showBeforeAfter)}
            className={`
              inline-flex items-center px-8 py-4 text-lg font-semibold rounded-full 
              transition-all duration-300 shadow-lg transform hover:scale-105
              ${showBeforeAfter 
                ? 'bg-gray-800 text-white' 
                : 'bg-blue-600 hover:bg-blue-700 text-white'}
            `}
          >
            {showBeforeAfter ? "Hide Transformation Gallery" : "See Real Patient Results →"}
          </button>
        </div>

        {/* Before/After Gallery */}
        {showBeforeAfter && (
          <div className="mt-4 mb-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
            <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
              Clinical Success Stories
            </h3>
            <div className="overflow-x-auto pb-8 no-scrollbar">
              <div className="flex gap-6 px-4 min-w-max">
                {beforeAfterCases.map((item, idx) => (
                  <div key={idx} className="w-[320px] md:w-[400px] flex-shrink-0">
                    <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
                      <BeforeAfterSlider
                        beforeSrc={item.beforeSrc}
                        afterSrc={item.afterSrc}
                        title={item.title}
                        description={item.description}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Footer CTA */}
        <div className="text-center mt-8">
          <a
            href="https://www.google.com/search?sca_esv=e1704c1572f6a3bb&sxsrf=ANbL-n7AG-v65O_H4y-KoJM837P432Jk5g:1772182885584&si=AL3DRZHrmvnFAVQPOO2Bzhf8AX9KZZ6raUI_dT7DG_z0kV2_x5vecDXR0TvhkvwVLPyiVDnbKxzdwrB9nuYp-j--uvG6PKJwFy-K4xQZnU7c8NZdvQbmsLblkau3QmpL5_FVrLcgV99TKGE9-hZ98sM698wEMm1F3_MpnXSqZ-z2bqTkI0tiuGQ%3D&q=Dr.+Sridhar+International+Dental+Hospital+Reviews&sa=X&ved=2ahUKEwjU8Pzap_mSAxWVnWoFHRk5GwkQ0bkNegQINxAH&biw=1470&bih=831&dpr=2"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 font-bold rounded-full transition-all text-md"
          >
            Read All 700+ Google Reviews
          </a>
        </div>
      </div>

      <style jsx>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>
  );
};

export default TestimonialSlider;